import { render, staticRenderFns } from "./PayPeriod.vue?vue&type=template&id=fdd38f16&scoped=true&"
import script from "./PayPeriod.vue?vue&type=script&lang=js&"
export * from "./PayPeriod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdd38f16",
  null
  
)

export default component.exports